import iconMap from "../../../../assets/icon_as_map.svg";
import iconTag from "../../../../assets/icon_store_tag.svg";
import iconDate from "../../../../assets/icon_store_date.svg";

const ContactItem = ({ iconSrc, children }) => (
  <li className="flex gap-2.5 font-medium text-neutral-500 leading-7">
    <span className="flex items-center justify-center w-8 h-8 rounded-full bg-neutral-100 shrink-0">
      <img src={iconSrc} alt="" />
    </span>
    <p className="leading-8">{children}</p>
  </li>
);

const StoreNewsList = ({ newsList }) => {
  return (
    <ul className="flex flex-col">
      {newsList?.map(
        ({ id, title, gcode_name, location, from_date, due_date }) => (
          <li className="border-b py-7" key={id}>
            <h3 className="text-xl font-semibold mb-2.5">{title}</h3>

            <ul className="flex flex-col gap-1">
              {gcode_name && (
                <ContactItem iconSrc={iconTag}>{gcode_name}</ContactItem>
              )}
              {location && (
                <ContactItem iconSrc={iconMap}>{location}</ContactItem>
              )}
              {from_date && due_date && (
                <ContactItem iconSrc={iconDate}>
                  {from_date} ~ {due_date}
                </ContactItem>
              )}

              {/* You can add more conditions for rendering other elements */}
            </ul>
          </li>
        )
      )}
    </ul>
  );
};

export default StoreNewsList;
